import React from 'react';

import { Box, CircularProgress } from '@mui/material';

import { useGetCurationDetail } from '~/hooks/apis/bedbank/useCuration';

import CurationRowDetail from '../CurationRowDetail';
import { CurationItem } from '../types';

interface Props {
  row: CurationItem;
}

export default function CurationDetailPanel({ row }: Props) {
  const { data: detail, isLoading } = useGetCurationDetail(row.propertyId);

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" py={3}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  return <CurationRowDetail row={detail ?? row} />;
}
